import React, { useState, useEffect } from "react";
import Pitch from "./Pitch";
import "./css/TeamManagementModal.css";
import config from "./config";

const devLog = (...args) => {
  if (config.IS_DEV) {
    console.log(...args);
  }
};

const TeamManagementModal = ({
  formation,
  formationCoordinates,
  formationPositions,
  onUpdateFormation,
  playerSelections = [],
  setPlayerSelections,
  positionAssignments,
  markerColor,
  gkColor,
  matchType,
  playerStats = [],
  setPlayerStats,
}) => {
  const [formationModalOpen, setFormationModalOpen] = useState(false);
  devLog("Inside TeamManagementModal, playerStats:", playerStats);
  devLog("Type of playerStats:", typeof playerStats);
  devLog("Is Array:", Array.isArray(playerStats));
  useEffect(() => {
    devLog("playerStats:", playerStats, Array.isArray(playerStats));
  }, [playerStats]);

  useEffect(() => {
    if (formationModalOpen) {
      devLog("Player tm Stats:", playerStats);
    }
  }, [formationModalOpen, playerStats]);
  const playingPlayers = Array.isArray(playerStats)
    ? playerStats.filter((player) => player.status == "playing")
    : [];

  devLog("Playing players:", playingPlayers);

  // Define formations per match type with coordinates
  const formationsByMatchType = {
    5: [
      {
        name: "1-2-1",
        positions: ["GK", "DEF", "MID-L", "MID-R", "FWD"],
        coordinates: [
          { top: 85, left: 50 }, // GK
          { top: 60, left: 50 }, // DEF
          { top: 37, left: 30 }, // MID-L
          { top: 37, left: 70 }, // MID-R
          { top: 15, left: 50 }, // FWD
        ],
      },
      {
        name: "2-1-1",
        positions: ["GK", "DEF-L", "DEF-R", "MID", "FWD"],
        coordinates: [
          { top: 85, left: 50 }, // GK
          { top: 60, left: 30 }, // DEF-L
          { top: 60, left: 70 }, // DEF-R
          { top: 37, left: 50 }, // MID
          { top: 15, left: 50 }, // FWD
        ],
      },
    ],
    6: [
      {
        name: "2-1-2",
        positions: ["GK", "DEF-L", "DEF-R", "MID", "FWD-L", "FWD-R"],
        coordinates: [
          { top: 85, left: 50 }, // GK
          { top: 60, left: 35 }, // DEF-L
          { top: 60, left: 65 }, // DEF-R
          { top: 45, left: 50 }, // MID
          { top: 25, left: 30 }, // FWD-L
          { top: 25, left: 70 }, // FWD-R
        ],
      },
      {
        name: "2-2-1",
        positions: ["GK", "DEF-L", "DEF-R", "MID-L", "MID-R", "FWD"],
        coordinates: [
          { top: 85, left: 50 }, // GK
          { top: 60, left: 40 }, // DEF-L
          { top: 60, left: 60 }, // DEF-R
          { top: 40, left: 30 }, // MID-L
          { top: 40, left: 70 }, // MID-R
          { top: 25, left: 50 }, // FWD
        ],
      },
      {
        name: "3-1-1",
        positions: ["GK", "DEF-L", "DEF-C", "DEF-R", "MID", "FWD"],
        coordinates: [
          { top: 85, left: 50 }, // GK
          { top: 63, left: 30 }, // DEF-L
          { top: 63, left: 50 }, // DEF-C
          { top: 63, left: 70 }, // DEF-R
          { top: 45, left: 50 }, // MID
          { top: 25, left: 50 }, // FWD
        ],
      },
    ],
    7: [
      {
        name: "2-3-1",
        positions: ["GK", "DEF-L", "DEF-R", "MID-L", "MID-C", "MID-R", "FWD"],
        coordinates: [
          { top: 85, left: 50 }, // GK
          { top: 60, left: 35 }, // DEF-L
          { top: 60, left: 65 }, // DEF-R
          { top: 37, left: 25 }, // MID-L
          { top: 37, left: 50 }, // MID-C
          { top: 37, left: 75 }, // MID-R
          { top: 15, left: 50 }, // FWD
        ],
      },
      {
        name: "3-2-1",
        positions: ["GK", "DEF-L", "DEF-C", "DEF-R", "MID-L", "MID-R", "FWD"],
        coordinates: [
          { top: 85, left: 50 }, // GK
          { top: 60, left: 25 }, // DEF-L
          { top: 60, left: 50 }, // DEF-C
          { top: 60, left: 75 }, // DEF-R
          { top: 37, left: 40 }, // MID-L
          { top: 37, left: 60 }, // MID-R
          { top: 15, left: 50 }, // FWD
        ],
      },
    ],
    9: [
      {
        name: "3-3-2",
        positions: [
          "GK",
          "CB-L",
          "CB-C",
          "CB-R",
          "MID-L",
          "MID-C",
          "MID-R",
          "FWD-L",
          "FWD-R",
        ],
        coordinates: [
          { top: 85, left: 50 }, // GK
          { top: 60, left: 30 }, // CB-L
          { top: 60, left: 50 }, // CB-C
          { top: 60, left: 70 }, // CB-R
          { top: 37, left: 20 }, // MID-L
          { top: 37, left: 50 }, // MID-C
          { top: 37, left: 80 }, // MID-R
          { top: 15, left: 40 }, // FWD-L
          { top: 15, left: 60 }, // FWD-R
        ],
      },
      {
        name: "4-3-1",
        positions: [
          "GK",
          "LB",
          "CB-L",
          "CB-R",
          "RB",
          "MID-L",
          "MID-C",
          "MID-R",
          "FWD",
        ],
        coordinates: [
          { top: 85, left: 50 }, // GK
          { top: 60, left: 20 }, // LB
          { top: 60, left: 40 }, // CB-L
          { top: 60, left: 60 }, // CB-R
          { top: 60, left: 80 }, // RB
          { top: 37, left: 30 }, // MID-L
          { top: 37, left: 50 }, // MID-C
          { top: 37, left: 70 }, // MID-R
          { top: 15, left: 50 }, // FWD
        ],
      },
      {
        name: "3-1-3-1",
        positions: [
          "GK",
          "CB-L",
          "CB-C",
          "CB-R",
          "CDM",
          "MID-L",
          "MID-C",
          "MID-R",
          "FWD",
        ],
        coordinates: [
          { top: 88, left: 50 }, // GK
          { top: 71, left: 30 }, // CB-L
          { top: 71, left: 50 }, // CB-C
          { top: 71, left: 70 }, // CB-R
          { top: 52, left: 50 }, // CB-R
          { top: 32, left: 30 }, // MID-L
          { top: 32, left: 50 }, // MID-C
          { top: 32, left: 70 }, // MID-R
          { top: 13, left: 50 }, // FWD
        ],
      },
      {
        name: "3-4-1",
        positions: [
          "GK",
          "CB-L",
          "CB-C",
          "CB-R",
          "MID-L",
          "MID-C",
          "MID-C",
          "MID-R",
          "FWD",
        ],
        coordinates: [
          { top: 85, left: 50 }, // GK
          { top: 60, left: 30 }, // CB-L
          { top: 60, left: 50 }, // CB-C
          { top: 60, left: 70 }, // CB-R
          { top: 37, left: 20 }, // MID-L
          { top: 37, left: 40 }, // MID-C
          { top: 37, left: 60 }, // MID-C
          { top: 37, left: 80 }, // MID-R
          { top: 15, left: 50 }, // FWD
        ],
      },
    ],
    11: [
      {
        name: "4-4-2",
        positions: [
          "GK",
          "LB",
          "CB-L",
          "CB-R",
          "RB",
          "LM",
          "CM-L",
          "CM-R",
          "RM",
          "ST-L",
          "ST-R",
        ],
        coordinates: [
          { top: 85, left: 50 }, // GK
          { top: 60, left: 20 }, // LB
          { top: 60, left: 40 }, // CB-L
          { top: 60, left: 60 }, // CB-R
          { top: 60, left: 80 }, // RB
          { top: 37, left: 15 }, // LM
          { top: 37, left: 40 }, // CM-L
          { top: 37, left: 60 }, // CM-R
          { top: 37, left: 85 }, // RM
          { top: 15, left: 40 }, // ST-L
          { top: 15, left: 60 }, // ST-R
        ],
      },
      {
        name: "4-3-3",
        positions: [
          "GK",
          "LB",
          "CB-L",
          "CB-R",
          "RB",
          "CM-L",
          "CM-C",
          "CM-R",
          "LW",
          "ST",
          "RW",
        ],
        coordinates: [
          { top: 85, left: 50 }, // GK
          { top: 63, left: 20 }, // LB
          { top: 63, left: 40 }, // CB-L
          { top: 63, left: 60 }, // CB-R
          { top: 63, left: 80 }, // RB
          { top: 43, left: 30 }, // CM-L
          { top: 43, left: 50 }, // CM-C
          { top: 43, left: 70 }, // CM-R
          { top: 25, left: 20 }, // LW
          { top: 10, left: 50 }, // ST
          { top: 25, left: 80 }, // RW
        ],
      },
      {
        name: "3-5-2",
        positions: [
          "GK",
          "CB-L",
          "CB-C",
          "CB-R",
          "LWB",
          "CM-L",
          "CM-C",
          "CM-R",
          "RWB",
          "ST-L",
          "ST-R",
        ],
        coordinates: [
          { top: 85, left: 50 }, // GK
          { top: 60, left: 30 }, // CB-L
          { top: 60, left: 50 }, // CB-C
          { top: 60, left: 70 }, // CB-R
          { top: 45, left: 15 }, // LWB
          { top: 32, left: 35 }, // CM-L
          { top: 32, left: 50 }, // CM-C
          { top: 32, left: 65 }, // CM-R
          { top: 45, left: 85 }, // RWB
          { top: 10, left: 40 }, // ST-L
          { top: 10, left: 60 }, // ST-R
        ],
      },
      {
        name: "4-2-3-1",
        positions: [
          "GK",
          "LB",
          "CB-L",
          "CB-R",
          "RB",
          "CDM-L",
          "CDM-R",
          "LW",
          "CAM",
          "RW",
          "ST",
        ],
        coordinates: [
          { top: 85, left: 50 }, // GK
          { top: 67, left: 20 }, // LB
          { top: 67, left: 40 }, // CB-L
          { top: 67, left: 60 }, // CB-R
          { top: 67, left: 80 }, // RB
          { top: 50, left: 40 }, // CDM-L
          { top: 50, left: 60 }, // CDM-R
          { top: 32, left: 20 }, // LW
          { top: 32, left: 50 }, // CAM
          { top: 32, left: 80 }, // RW
          { top: 15, left: 50 }, // ST
        ],
      },
    ],
  };

  const handleFormationSelect = (selectedFormation) => {
    const newAssignments = handlePositionAssignments(
      positionAssignments,
      selectedFormation.positions,
      playerStats
    );

    onUpdateFormation({
      formation: selectedFormation.name,
      formationCoordinates: selectedFormation.coordinates,
      formationPositions: selectedFormation.positions,
      positionAssignments: newAssignments, // Set new position assignments
    });
  };

  const handlePositionAssignments = (
    oldAssignments,
    newFormationPositions,
    players
  ) => {
    const updatedAssignments = {};
    const assignedPlayerIds = new Set(); // To keep track of assigned players

    // Loop through the new formation positions
    newFormationPositions.forEach((position, index) => {
      // Try to retain players assigned to old positions
      const oldPositionIndex = Object.keys(oldAssignments).find(
        (key) => oldAssignments[key] && newFormationPositions[key] === position
      );
      if (
        oldPositionIndex &&
        !assignedPlayerIds.has(oldAssignments[oldPositionIndex])
      ) {
        updatedAssignments[index] = oldAssignments[oldPositionIndex];
        assignedPlayerIds.add(oldAssignments[oldPositionIndex]);
      } else {
        // Find the next available player not yet assigned
        const availablePlayer = players.find(
          (player) => !assignedPlayerIds.has(player.player_id)
        );
        if (availablePlayer) {
          updatedAssignments[index] = availablePlayer.player_id;
          assignedPlayerIds.add(availablePlayer.player_id);
        } else {
          updatedAssignments[index] = null; // No available player for this position
        }
      }
    });

    return updatedAssignments;
  };
  const [swapPlayerAssignments, setSwapPlayerAssignments] = useState({
    ...positionAssignments,
  });
  // In TeamManagementModal.js
  // (Other state and effects as in your original code)
  // For updating the position assignments we define an onPositionAssignmentChange
  const onPositionAssignmentChange = (posIndex, newAssignmentsOrPlayerId) => {
    if (posIndex === null) {
      // newAssignmentsOrPlayerId is an object
      onUpdateFormation({
        formation,
        formationCoordinates,
        formationPositions,
        positionAssignments: newAssignmentsOrPlayerId,
      });
    } else {
      // Single assignment update
      const newAssignments = {
        ...positionAssignments,
        [posIndex]: newAssignmentsOrPlayerId,
      };
      onUpdateFormation({
        formation,
        formationCoordinates,
        formationPositions,
        positionAssignments: newAssignments,
      });
    }
  };

  const handlePlayerChange = (positionIndex, newPlayerId) => {
    const updatedAssignments = { ...swapPlayerAssignments };

    const currentAssignedPlayerId = updatedAssignments[positionIndex];

    // Find if the new player is already assigned to another position
    const previousPositionIndex = Object.keys(updatedAssignments).find(
      (key) => updatedAssignments[key] === newPlayerId
    );

    if (previousPositionIndex !== undefined) {
      // Swap the players
      updatedAssignments[previousPositionIndex] = currentAssignedPlayerId;
    }

    // Assign the new player to the current position
    updatedAssignments[positionIndex] = newPlayerId;

    // Update player statuses and positions immediately
    const updatedPlayers = playerStats.map((player) => {
      const assignedPositionIndex = Object.keys(updatedAssignments).find(
        (index) => updatedAssignments[index] === player.player_id
      );
      if (assignedPositionIndex !== undefined) {
        const positionIndex = parseInt(assignedPositionIndex);
        return {
          ...player,
          status: "playing",
          position: formationPositions[positionIndex],
        };
      } else {
        return {
          ...player,
          status: "sub",
          position: "bench",
        };
      }
    });

    setSwapPlayerAssignments(updatedAssignments);
    setPlayerStats(updatedPlayers); // Update players in real-time
  };

  const handleSaveAssignments = () => {
    // Check if all positions are filled
    const allPositionsFilled = formationPositions.every(
      (_, index) => swapPlayerAssignments[index]
    );

    if (!allPositionsFilled) {
      alert("Please fill all positions before saving.");
      return;
    }

    // Update player statuses and positions
    const updatedPlayers = playerStats.map((player) => {
      const assignedPositionIndex = Object.keys(swapPlayerAssignments).find(
        (index) => swapPlayerAssignments[index] === player.player_id
      );
      if (assignedPositionIndex !== undefined) {
        const positionIndex = parseInt(assignedPositionIndex);
        return {
          ...player,
          status: "playing",
          position: formationPositions[positionIndex],
        };
      } else {
        return {
          ...player,
          status: "sub",
          position: "bench",
        };
      }
    });

    // Update the playerStats state
    setPlayerStats(updatedPlayers);

    // Save the updated formation
    onUpdateFormation({
      formation,
      formationCoordinates,
      formationPositions,
      positionAssignments: swapPlayerAssignments,
    });
  };

  return (
    <div className="tm-centered-container">
      {/* Formation Modal */}
      {formationModalOpen && (
        <div className="modal-overlay" style={{ overflowY: "hidden" }}>
          <div
            className="modal-content"
            style={{
              maxHeight: "90vh", // Limit modal height to 90% of viewport height
              maxWidth: "80vw", // Limit modal width to 80% of viewport width
              width: "80%", // Set width to 80% of the container
              margin: "0 auto", // Center the modal horizontally
              overflowY: "auto", // Enable scrolling if content exceeds the height
              padding: "20px",
              backgroundColor: "#fff",
              borderRadius: "10px",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            }}
          >
            <h3>Formation</h3>
            {/* Formation Options */}
            {/* <h4>Select Formation</h4> */}
            <select
              value={formation} // Set the current formation as the selected value
              onChange={(e) => {
                const selectedForm = formationsByMatchType[matchType]?.find(
                  (form) => form.name === e.target.value
                );
                if (selectedForm) handleFormationSelect(selectedForm);
              }}
              style={{
                width: "100%", // Make it responsive
                padding: "10px",
                marginBottom: "10px",
                border: "1px solid gray",
                borderRadius: "5px",
              }}
            >
              <option value="" disabled>
                Select a Formation
              </option>
              {formationsByMatchType[matchType]?.map((form, index) => (
                <option key={index} value={form.name}>
                  {form.name} - Positions: {form.positions.join(", ")}
                </option>
              )) || (
                <option disabled>
                  No formations available for this match type.
                </option>
              )}
            </select>
            <hr />
            {/* Player Assignment Management */}
            {/* <h4>Manage Player Assignments</h4>
            <form>
              {formationPositions.map((position, index) => {
                const currentPlayerId = swapPlayerAssignments[index];
                const currentPlayer = playerStats.find(
                  (p) => p.player_id === currentPlayerId
                );

                const isPositionUnfilled = !currentPlayerId; // Check if the position is unfilled

                return (
                  <div
                    key={index}
                    className="position-row"
                    style={{
                      border: isPositionUnfilled ? "1px solid red" : "none", // Highlight unfilled positions
                      padding: "5px",
                      marginBottom: "5px",
                    }}
                  >
                    <label>{position}:</label>
                    <select
                      value={currentPlayerId || ""}
                      onChange={(e) =>
                        handlePlayerChange(index, e.target.value)
                      } // Handle player selection
                      style={{
                        backgroundColor: isPositionUnfilled
                          ? "#ffcccc"
                          : "white", // Highlight missing positions red
                      }}
                    >
                      <option value="" disabled>
                        Select a player
                      </option> */}
            {/* All selected players across all dropdowns */}
            {/* {playerStats
                        .filter((player) =>
                          Object.values(swapPlayerAssignments).includes(
                            player.player_id
                          )
                        ) // Only players currently assigned
                        .map((player) => (
                          <option
                            key={player.player_id}
                            value={player.player_id}
                          >
                            {player.player_name || "Unnamed"}
                          </option>
                        ))}

                      {/* Add a horizontal line */}
            {/* <option disabled>──────────</option> */}
            {/* Remaining players */}
            {/* {playerStats
                        .filter(
                          (player) =>
                            !Object.values(swapPlayerAssignments).includes(
                              player.player_id
                            ) && // Exclude already selected players
                            player.status !== "home" // Exclude home players
                        )
                        //.sort((a, b) => (a.status === "sub" ? 1 : -1)) // Sort by playing and sub status
                        .map((player) => (
                          <option
                            key={player.player_id}
                            value={player.player_id}
                          >
                            {player.player_name || "Unnamed"}
                          </option>
                        ))}
                    </select>
                  </div>
                );
              })}
            </form> */}
            {/* Save Button with Validation */}
            {/* <button
              onClick={() => {
                // Check if all positions are filled
                const allPositionsFilled = formationPositions.every(
                  (_, index) => swapPlayerAssignments[index]
                );

                if (!allPositionsFilled) {
                  // Prevent saving if positions are unfilled
                  return;
                }

                // Save the assignments
                handleSaveAssignments();

                // Close the modal
                setFormationModalOpen(false);
              }}
              disabled={formationPositions.some(
                (_, index) => !swapPlayerAssignments[index]
              )} // Disable if any position is unfilled
              style={{
                backgroundColor: formationPositions.some(
                  (_, index) => !swapPlayerAssignments[index]
                )
                  ? "gray"
                  : "blue", // Change button color when disabled
                cursor: formationPositions.some(
                  (_, index) => !swapPlayerAssignments[index]
                )
                  ? "not-allowed"
                  : "pointer", // Change cursor when disabled
                color: "white",
                padding: "10px 20px",
                marginTop: "10px",
              }}
            >
              Save Assignments
            </button> */}
            <button
              onClick={() => setFormationModalOpen(false)}
              style={{
                marginTop: "10px",
                padding: "10px 20px",
                backgroundColor: "red",
                color: "white",
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}
      <Pitch
        formationPositions={formationPositions}
        positionAssignments={positionAssignments}
        players={playerStats}
        setPlayerStats={setPlayerStats}
        coordinates={formationCoordinates}
        markerColor={markerColor}
        gkColor={gkColor}
        isPressToTalk={true}
        onPositionAssignmentChange={onPositionAssignmentChange} // <-- add this line
      />

      {/* Button to Open Formation Modal */}
      <button
        onClick={() => setFormationModalOpen(true)}
        className="team-management-button"
      >
        Select Formation{" "}
      </button>
    </div>
  );
};

export default TeamManagementModal;
